// Hook: IaC export (Terraform + Bicep) for a project.
//
// Encapsulates the POST /iac/... call, browser file download, and toast
// notifications. Extracted from ProjectOutput.jsx so callers just render
// two buttons and wire them to `onExportTerraform` / `onExportBicep`.

import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

function downloadText(filename, content) {
  const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function useIacExport(projectId) {
  const exportKind = async (kind) => {
    try {
      const { data } = await api.post(`/projects/${projectId}/iac/${kind}`);
      downloadText(data.filename, data.content);
      toast.success(`${kind === "terraform" ? "Terraform" : "Bicep"} downloaded`, {
        description: data.filename,
      });
    } catch (e) {
      toast.error("Export failed", {
        description: formatApiErrorDetail(e.response?.data?.detail) || e.message,
      });
    }
  };
  return {
    onExportTerraform: () => exportKind("terraform"),
    onExportBicep: () => exportKind("bicep"),
  };
}
